import * as React from 'react';

import { useQuery, QueryResult } from '@apollo/client';

import {
  GetShadefinderQueryQuery,
  GetShadefinderQueryQueryVariables,
} from '@notino/shared/definitions/types';

import getShadefinder from '../../queries/getShadefinderQuery.graphql';

import { onlyShadesWithExistingUndertones } from './helpers';

export const useShadefinderData = (
  masterId: string
): QueryResult<GetShadefinderQueryQuery> => {
  const { data: rawData, ...rest } = useQuery<
    GetShadefinderQueryQuery,
    GetShadefinderQueryQueryVariables
  >(getShadefinder, {
    variables: {
      productId: masterId,
    },
  });

  const data = React.useMemo(() => {
    if (rawData?.getShadefinder) {
      return {
        ...rawData,
        getShadefinder: {
          ...rawData.getShadefinder,
          shades: onlyShadesWithExistingUndertones(
            rawData.getShadefinder.shades
          ),
        },
      };
    }
    return undefined;
  }, [rawData]);

  return { data, ...rest };
};
